var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative flex-shrink-0 w-90" },
    [
      _c(
        "div",
        {
          staticClass:
            "h-12.5 px-3 flex items-center justify-between gap-4 flex-shrink-0"
        },
        [
          _c(
            "div",
            {
              staticClass: "flex items-center gap-2 truncate",
              attrs: { title: _vm.stage.name }
            },
            [
              _c("BlTextSubtitle1", {
                staticClass: "truncate",
                attrs: { text: _vm.stage.name }
              }),
              _vm._v(" "),
              !_vm.editState
                ? _c("BlBubbleCount", {
                    attrs: { count: _vm.stage.number_of_prospect || 0 }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              !_vm.editState
                ? _c("BlInputButton", {
                    attrs: {
                      type: "plain",
                      dense: "",
                      label: _vm.showDetails ? "Hide details" : "View details"
                    },
                    on: {
                      clicked: function($event) {
                        _vm.showDetails = !_vm.showDetails
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.editable &&
              !_vm.stage.is_admitted &&
              !_vm.stage.is_pending &&
              !_vm.stage.is_discontinued &&
              _vm.stage.position !== 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "handle_move_position h-6.5 w-30 flex items-center justify-center rounded-full bg-pure-white border border-slate-500 cursor-grab"
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "w-5 h-5",
                        style: { rotate: "90deg" },
                        attrs: { icon: "drag", color: "slate-6" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "relative flex flex-col overflow-y-auto border rounded shadow-md bg-pure-white border-slate-400",
          style: { height: "calc(100vh - 10rem - 3.625rem)" }
        },
        [
          _vm.editState
            ? _c(
                "div",
                { staticClass: "flex flex-col justify-between h-full" },
                [
                  _c("div", { staticClass: "p-3" }, [
                    _c(
                      "div",
                      { staticClass: "flex flex-col gap-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-between gap-2"
                          },
                          [
                            _c("BlTextSubtitle3", {
                              staticClass: "text-slate-800",
                              attrs: { text: "Stage name" }
                            }),
                            _vm._v(" "),
                            _vm.editState
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center flex-shrink-0 h-6 gap-2 px-2 rounded-full bg-success-100"
                                  },
                                  [
                                    _c("BlIcon", {
                                      staticClass: "w-4 h-4",
                                      class: {
                                        "animate-spin": _vm.saveLoading
                                      },
                                      attrs: {
                                        icon: "update",
                                        color: "success"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.saveLoading
                                      ? _c("BlTextBody2", {
                                          staticClass: "text-success",
                                          attrs: { text: "Saving" }
                                        })
                                      : _c("BlTextBody2", {
                                          staticClass: "text-success",
                                          attrs: { text: "Saved" }
                                        })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlInputText", {
                          attrs: { input: _vm.nameInput },
                          on: { changed: _vm.onInput }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "my-4 h-0.5 w-full bg-slate-300 rounded"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col gap-3" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex flex-col gap-1" },
                          [
                            _c("BlTextSubtitle3", {
                              staticClass: "text-slate-800",
                              attrs: { text: "Stage description" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "Create a brief description of this stage."
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlInputText", {
                          attrs: { input: _vm.descriptionInput },
                          on: { changed: _vm.onInput }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "my-4 h-0.5 w-full bg-slate-300 rounded"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex flex-col gap-3" }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-1" },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "text-slate-800",
                            attrs: { text: "Stage instructions" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Stage instructions are predefined instructions that automatically appear when a prospect moves to this stage."
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        _vm._l(_vm.stage.documents, function(doc) {
                          return _c("PipelineInstructionStage", {
                            key: doc.id,
                            attrs: {
                              instruction: doc,
                              stage: _vm.stage,
                              editable: ""
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("BlInputButton", {
                            attrs: {
                              type: "plain",
                              dense: "",
                              icon: "plus",
                              label: "Add instruction"
                            },
                            on: {
                              clicked: function($event) {
                                _vm.newInstructionOpened = true
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky bottom-0 flex items-center justify-center flex-shrink-0 h-10 gap-16 bg-pure-white"
                    },
                    [
                      !_vm.stage.is_admitted &&
                      !_vm.stage.is_pending &&
                      !_vm.stage.is_discontinued &&
                      _vm.stage.position !== 1
                        ? _c("BlInputButton", {
                            attrs: {
                              type: "plain-error",
                              label: "Delete stage"
                            },
                            on: {
                              clicked: function($event) {
                                _vm.deleteOpened = true
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.editable
                        ? _c("BlInputButton", {
                            attrs: { type: "plain", label: "Close" },
                            on: {
                              clicked: function($event) {
                                _vm.editState = false
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm.showDetails
            ? _c(
                "div",
                { staticClass: "flex flex-col justify-between h-full" },
                [
                  _c("div", { staticClass: "p-3" }, [
                    _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _vm.stage.description
                          ? _c("BlTextBody2", {
                              staticClass: "whitespace-pre-line text-slate-800",
                              attrs: { text: _vm.stage.description || "-" }
                            })
                          : _c("BlTextBody2", {
                              staticClass: "italic text-slate-800",
                              attrs: { text: "No description" }
                            })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2 mb-2" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "h-7.5 w-7.5 flex-shrink-0 flex items-center justify-center bg-slate-200 rounded"
                          },
                          [
                            _c("BlIcon", {
                              staticClass: "w-5 h-5",
                              attrs: { icon: "to-do", color: "slate-6" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlTextSubtitle3", {
                          attrs: { text: "Stage instructions" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.stage.documents.length
                      ? _c(
                          "div",
                          [
                            _c("BlTextBody2", {
                              staticClass: "italic text-slate-800",
                              attrs: { text: "No instruction" }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "flex flex-col gap-2" },
                          _vm._l(_vm.stage.documents, function(doc) {
                            return _c("PipelineInstructionStage", {
                              key: doc.id,
                              attrs: { instruction: doc, stage: _vm.stage }
                            })
                          }),
                          1
                        )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky bottom-0 flex items-center justify-center flex-shrink-0 h-10 bg-pure-white"
                    },
                    [
                      _c("BlInputButton", {
                        attrs: { type: "plain", label: "Edit stage" },
                        on: {
                          clicked: function($event) {
                            _vm.editState = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _c(
                "div",
                { staticClass: "flex flex-col p-3" },
                [
                  _vm.fetchLoading
                    ? _c(
                        "div",
                        { staticClass: "grid w-full h-92 place-items-center" },
                        [_c("div", { staticClass: "blum-loader" })]
                      )
                    : !_vm.stage.prospect_stages.length
                    ? _c(
                        "div",
                        { staticClass: "grid w-full h-92 place-items-center" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-center text-slate-700",
                            attrs: {
                              text: "Oops, there are no prospect available."
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "flex flex-col gap-3" },
                        _vm._l(_vm.stage.prospect_stages, function(
                          prospectStage
                        ) {
                          return _c("PipelineProspectStage", {
                            key: prospectStage.id,
                            attrs: { item: prospectStage, dragId: _vm.dragId },
                            on: {
                              "drag-start": function($event) {
                                return _vm.$emit("drag-start", $event)
                              }
                            }
                          })
                        }),
                        1
                      ),
                  _vm._v(" "),
                  _vm.stage.number_of_prospect > _vm.perPage
                    ? _c("BlInputPagination", {
                        staticClass: "sticky z-10 pt-3 bottom-3",
                        attrs: {
                          count: Math.ceil(
                            _vm.stage.number_of_prospect / _vm.perPage
                          ),
                          page: _vm.page
                        },
                        on: { changed: _vm.changePage }
                      })
                    : _vm._e()
                ],
                1
              )
        ]
      ),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete stage",
                label: "Confirm",
                type: "error",
                disabled: _vm.disabledDelete
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteOpened = false
                },
                "backdrop-action": _vm.onRemove
              }
            },
            [
              !_vm.stage.number_of_prospect
                ? _c(
                    "div",
                    { staticClass: "px-8" },
                    [
                      _c("BlTextBody2", {
                        attrs: { text: "You are about to remove the " }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "font-bold",
                        attrs: { text: _vm.stage.name }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text: "stage. Are you sure you want to proceed?"
                        }
                      })
                    ],
                    1
                  )
                : _c("div", { staticClass: "px-8" }, [
                    _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "You have " +
                              _vm.stage.number_of_prospect +
                              " prospect(s) in the "
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "font-bold",
                          attrs: { text: _vm.stage.name }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "stage. Please select where these prospects will be moved to:"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c("BlSelectBox", {
                          attrs: {
                            placeholder: "Select stage",
                            options: _vm.stageOptions,
                            search: ""
                          },
                          on: {
                            change: function($event) {
                              _vm.movedStageInput = $event
                            }
                          },
                          model: {
                            value: _vm.movedStageInput,
                            callback: function($$v) {
                              _vm.movedStageInput = $$v
                            },
                            expression: "movedStageInput"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.destinationStage.is_discontinued
                      ? _c(
                          "div",
                          { staticClass: "mb-4" },
                          [
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "Please provide the reason for the prospect's decision to discontinue during the client acquisition process. If the prospect returns, their profile can be reopened at any time."
                              }
                            }),
                            _vm._v(" "),
                            _c("BlSelectBox", {
                              staticClass: "mt-4",
                              attrs: {
                                placeholder: "Select reason",
                                options: _vm.reasonOptions
                              },
                              on: {
                                change: function($event) {
                                  _vm.reasonInput = $event
                                }
                              },
                              model: {
                                value: _vm.reasonInput,
                                callback: function($$v) {
                                  _vm.reasonInput = $$v
                                },
                                expression: "reasonInput"
                              }
                            }),
                            _vm._v(" "),
                            _vm.reasonInput === "other"
                              ? _c("BlInputText", {
                                  staticClass: "mt-2",
                                  attrs: { input: _vm.otherReasonInput },
                                  on: { changed: _vm.inputHandler }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "Alternatively, you can manually move these prospects to another stage before deleting this one."
                          }
                        })
                      ],
                      1
                    )
                  ]),
              _vm._v(" "),
              _vm.deleteLoading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "absolute flex justify-end w-full px-16 -bottom-12"
                    },
                    [_c("div", { staticClass: "blum-loader-btn" })]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("NewInstructionStagePanel", {
        attrs: { open: _vm.newInstructionOpened, stage: _vm.stage },
        on: {
          "close-panel": function($event) {
            _vm.newInstructionOpened = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02d8a8a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02d8a8a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/pipeline/Stage.vue
// module id = null
// module chunks = 